// components/AboutSection.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutSection.css';

function AboutSectionENG() {
  const [activeTab, setActiveTab] = useState('headquarters');

  const tabs = {
    headquarters: {
      icon: '/images/Asset5.png',
      title: 'At CNDH',
      description: 'A national symposium under the theme "Technology-facilitated violence against women and girls – a silent digital pandemic".',
      link: '/en/conference'
    },
    conference: {
      icon: '/images/Asset5.png',
      title: 'Symposium',
      description: 'A national symposium under the theme "Technology-facilitated violence against women and girls – a silent digital pandemic". ',
      link: '/en/conference'
    },
    show: {
      icon: '/images/Asset6.png',
      title: 'Daily mapping show',
      description: 'Messages, expressions, and artworks lighting up the main façade of the National Human Rights Council, every day, creating a powerful visual experience that raises awareness on digital violence against women and girls.',
      link: '/en/conference'
    },
    caravan: {
      icon: '/images/Asset4.png',
      title: 'National caravan',
      description: 'An itinerant caravan traveling to 12 cities across Morocco s 12 regions, interacting with communities, survivors, passersby and raising awareness on technology-facilitated violence against women and girls.',
      link: '/en/caravan'
    },
    music: {
      icon: '/images/Asset8.png',
      title: 'Art shows on human rights',
      description: 'Expressions of Rights: Every evening from 6:00 PM to 6:30 PM, open-air performances within the exhibitions, showcasing the creativity of young artists and their commitment to women s rights.',
      link: '/en/music'
    },
    stands: {
      icon: '/images/Asset7.png',
      title: 'Exhibitions',
      description: 'Interactive exhibitions in three major public squares in Rabat, inviting residents, visitors, and travelers to learn about digital violence against women and girls.',
      link: '/en/stands'
    },
    closingEvent: {
      icon: '/images/Asset10.png',
      title: 'Expressions of Rights',
      description: 'Expressions of Rights: Artistic expressions on the last day of the national campaign against digital violence and commemorating the 80th anniversary of International Human Rights Day.',
      link: '/en/closing-event'
    }
  };

  return (
    <section className="about-section">
      <div className="container">
        <h2 className="about-title">About the campaign</h2>

        <div className="about-content" >
          <p className="about-intro">
            National campaign to end digital violence against women and girls
          </p>

          <div className="about-details">
            <div className="detail-card">
              <div className="detail-label"><img src="/images/duration.png" className="tab-icon2-img" /></div>
              <div className="detail-value" style={{ direction:'ltr' }}>16 days</div>
            </div>
            <div className="detail-card">
              <div className="detail-label"><img src="/images/calandarv.png" className="tab-icon2-img" /></div>
              <div className="detail-value">November 25 – December 10, 2025</div>
            </div>
          </div>
        </div>

        <div className="tabs-container" style={{ direction:'ltr' }}>
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === 'headquarters' ? 'active' : ''}`}
              onClick={() => setActiveTab('headquarters')}
            >
              At CNDH
            </button>
            <button
              className={`tab-button ${activeTab === 'caravan' ? 'active' : ''}`}
              onClick={() => setActiveTab('caravan')}
            >
              National caravan
            </button>
            <button
              className={`tab-button ${activeTab === 'stands' ? 'active' : ''}`}
              onClick={() => setActiveTab('stands')}
            >
              Exhibitions
            </button>
            <button
              className={`tab-button ${activeTab === 'closingEvent' ? 'active' : ''}`}
              onClick={() => setActiveTab('closingEvent')}
            >
              Expressions of Rights
            </button>
          </div>

          <div className="tab-content" >
            {activeTab === 'headquarters' ? (
              <div className="tab-double">
                <div className="tab-card">
                  <img src={tabs['conference'].icon} alt="Logo" className="tab-icon-img" />
                  <h3 className="tab-title">{tabs['conference'].title}</h3>
                  <p className="tab-description">{tabs['conference'].description}</p>
                  <Link to={tabs['conference'].link}>
                    <button className="cta-button">More</button>
                  </Link>
                </div>

                <div className="tab-card">
                  <img src={tabs['show'].icon} alt="Logo" className="tab-icon-img" />
                  <h3 className="tab-title">{tabs['show'].title}</h3>
                  <p className="tab-description">{tabs['show'].description}</p>
                  <Link to={tabs['show'].link}>
                    <button className="cta-button">More</button>
                  </Link>
                </div>
              </div>
            ) : activeTab === 'stands' ? (
              <div className="tab-double">
                <div className="tab-card">
                  <img src={tabs['stands'].icon} alt="Logo" className="tab-icon-img" />
                  <h3 className="tab-title">{tabs['stands'].title}</h3>
                  <p className="tab-description">{tabs['stands'].description}</p>
                  <Link to={tabs['stands'].link}>
                    <button className="cta-button">More</button>
                  </Link>
                </div>

                <div className="tab-card">
                  <img src={tabs['music'].icon} alt="Logo" className="tab-icon-img" />
                  <h3 className="tab-title">{tabs['music'].title}</h3>
                  <p className="tab-description">{tabs['music'].description}</p>
                  <Link to={tabs['music'].link}>
                    <button className="cta-button">More</button>
                  </Link>
                </div>
              </div>
            ) : (
              <>
                <img src={tabs[activeTab].icon} alt="Logo" className="tab-icon-img" />
                <h3 className="tab-title">{tabs[activeTab].title}</h3>
                <p className="tab-description">{tabs[activeTab].description}</p>
                <Link to={tabs[activeTab].link}>
                  <button className="cta-button">More</button>
                </Link>
              </>
            )}
          </div>

        </div>
      </div>
    </section>
  );
}

export default AboutSectionENG;
